import React from "react";
import "./SecurityWhat.css";
import img from "../securityassets/whatimg.png";

export default function SecurityWhat() {
  return (
    <div id="security-what" className="outsourcemainclass">
      <div className="left">
        <img src={img} alt="error" />
      </div>
      <div className="right">
        <h2 className="heading">What Is DevOps Scalability?</h2>
        <p className="subheading">
          DevOps scalability is the practice of designing systems, applications,
          and infrastructure that can dynamically adapt to changing workloads.
          By combining automation, cloud-native technologies, and DevOps best
          practices, scalability ensures applications can grow or shrink based
          on demand, delivering consistent performance, high availability, and
          cost efficiency.
        </p>
        <button>Let's Discuss Your Project</button>
      </div>
    </div>
  );
}
